export enum SendType {
    Text = 0,
    File = 1,
}
